/* eslint-disable no-useless-escape */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tiles, Modal, Text, Container, Content, Title, Loader, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { setCurrentSidebarItem } from '../../actions/user.js';
import loadingGif from '../../assets/loading.gif';
import { snakeCapitalCase, downloadPDFToBrowser } from '../../services/helpers.js';
import { saveAs } from 'file-saver';

class Resources extends PureComponent {
    state = {
        loading: false,
        bookletGenerated: false
    };

    componentDidMount() {
        this.props.dispatch(setCurrentSidebarItem('resources'));
    }

    _downloadMemberBookletPDF = () => {
        this.setState({
            loading: true
        });
         
        const name = this.props.whitelabel.name;
        const fileName = name ? `${ snakeCapitalCase(name) }_Member_Booklet.pdf` : "Simply_Benefits_Member_Booklet.pdf";

        downloadPDFToBrowser("MemberBooklet", fileName, this.props.dispatch);

        this.setState({
            loading: false
        });
    };

    _downloadPDFFromS3 = (accountID, bookletName, companyName) => {
        const url = `https://d6hvupc5g7lnm.cloudfront.net/member-booklets/${ accountID }/${ bookletName }`;
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', `${ companyName }_${ bookletName }`);
        link.setAttribute('target', "_blank");
        document.body.appendChild(link);
        link.click();
    };

    _downloadResourceFileFromS3 = (item) => {
        saveAs(`https://d6hvupc5g7lnm.cloudfront.net/files/${ item }`, item);
    };

    _close = () => {
        this.setState({
            loading: false
        });
    };

    _navigateTo = (url) => {
        window.open(url, "_blank");
    };

    render() {
        const { coverage, user, whitelabel } = this.props;
        const tiles = [];
        const accountID = user.meta.accountID;
        const classID = user.meta.classID;
        const companyName = user.meta.company.split(' ').join('_');
        const language = user.meta.language;
        const province = user.meta.province;

        const styles = {
            modalRow: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'
            },
            gif: {
                maxWidth: '25%',
                marginRight: 40
            }
        };

        if (this.props.loading) {
            return (
                <Loader whitelabel={ whitelabel } />
            );
        }

        // if the member has auto booklets set then use those otherwise if they have a manual booklet set use that
        if (user.meta.useAutoBooklet === 1) {
            tiles.push({
                title: i18n.t(tokens.labels.resources.memberBooklet),
                description: i18n.t(tokens.labels.resources.featuresAndDetailsOfYourCoverage),
                onClick: this._downloadMemberBookletPDF,
                icon: "Member Booklets",
                testid: "download-admin-booklet"
            });
        } else if (user.meta.hasBooklet === 1) {
            tiles.push({
                title: i18n.t(tokens.labels.resources.memberBooklet),
                description: i18n.t(tokens.labels.resources.featuresAndDetailsOfYourCoverage),
                onClick: () => this._downloadPDFFromS3(accountID, `${ classID }.pdf`, companyName),
                icon: "Member Booklets",
                testid: "download-admin-booklet"
            });
        }
        
        if (coverage.efap.benefitActive && coverage.efap.carrier === 'Kii') {
            if (coverage.efap.includeEmployeeAssistance) {
                tiles.push({
                    title: i18n.t(tokens.labels.resources.kiiEmployeeAndFamilyAssistance),
                    description: i18n.t(tokens.labels.resources.detailsOfYourEmployeeAndFamilyAssistanceCoverage),
                    onClick: () => this._navigateTo(i18n.locale === 'fr' ? 'https://d6hvupc5g7lnm.cloudfront.net/files/Kii_EFAP_Fr.pdf' : 'https://d6hvupc5g7lnm.cloudfront.net/files/Kii_EFAP_En.pdf'),
                    icon: 'Resources',
                    testid: "open-kii"
                });
            }

            if (coverage.efap.includeMedicalSecondOpinion) {
                tiles.push({
                    title: i18n.t(tokens.labels.resources.secondOpinion),
                    description: i18n.t(tokens.labels.resources.detailsOfYourMedicalSecondOpinionCoverage),
                    onClick: () => this._navigateTo('https://d6hvupc5g7lnm.cloudfront.net/files/Kii_Medical_Second_Opinion_En.pdf'),
                    icon: 'Resources',
                    testid: "open-kii"
                });
            }

            if (coverage.efap.includeEldercare) {
                tiles.push({
                    title: i18n.t(tokens.labels.resources.eldercare),
                    description: i18n.t(tokens.labels.resources.detailsEldercare),
                    onClick: () => this._navigateTo('https://d6hvupc5g7lnm.cloudfront.net/files/Kii_Eldercare_En.pdf'),
                    icon: 'Resources',
                    testid: "open-kii"
                });
            } 
        }

        if (coverage.efap.benefitActive && coverage.efap.carrier === 'Advica') {
            tiles.push({
                title: i18n.t(tokens.labels.resources.advicaEmployeeAndFamilyAssistance),
                description: i18n.t(tokens.labels.resources.detailsOfYourEmployeeAndFamilyAssistanceCoverage),
                onClick: () => this._navigateTo("https://d6hvupc5g7lnm.cloudfront.net/files/AdvicaEfapGuide.pdf"),
                icon: 'Resources',
                testid: "open-advica"
            });
        }

        if (coverage.efap.benefitActive && coverage.efap.carrier === 'Dialogue') {
            tiles.push({
                title: i18n.t(tokens.labels.resources.dialogueEmployeeAndFamilyAssistance),
                description: i18n.t(tokens.labels.resources.detailsOfYourEmployeeAndFamilyAssistanceCoverage),
                onClick: () => this._navigateTo("https://d6hvupc5g7lnm.cloudfront.net/files/Dialogue_Employee_Family_Assistance.pdf"),
                icon: 'Resources',
                testid: "open-dialogue"
            });
        }

        if (coverage.virtualHealthcare.benefitActive && coverage.virtualHealthcare.includeMaple === 1) {
            tiles.push({
                title: i18n.t(tokens.labels.resources.mapleVirtualHealthcare),
                description: i18n.t(tokens.labels.resources.detailsOfYourMapleCoverage),
                onClick: () => this._navigateTo("http://getmaple.ca/simply-benefits"),
                icon: 'Resources',
                testid: "open-maple"
            });
        }

        if (coverage.virtualHealthcare.benefitActive && coverage.virtualHealthcare.includeGotodoctor === 1) {
            tiles.push({
                title: i18n.t(tokens.labels.resources.gotodoctorVirtualHealthcare),
                description: i18n.t(tokens.labels.resources.detailsOfYourGotodoctorCoverage),
                onClick: () => this._navigateTo("https://d6hvupc5g7lnm.cloudfront.net/files/Simply_Benefits_Gotodoctor.ca_VirtualCare.pdf"),
                icon: 'Resources',
                testid: "open-gotodoctor"
            });
    
            tiles.push({
                title: i18n.t(tokens.labels.resources.gotodoctorSignup),
                description: i18n.t(tokens.labels.resources.signUpWithGotodoctor),
                onClick: () => this._navigateTo("https://d6hvupc5g7lnm.cloudfront.net/files/Simply_Benefits_Gotodoctor.ca_Sign_Up.pdf"),
                icon: 'Resources',
                testid: "open-gotodoctor"
            });
        }

        if (coverage.virtualHealthcare.benefitActive && coverage.virtualHealthcare.includeDialogue === 1) {
            tiles.push({
                title: i18n.t(tokens.labels.resources.dialogueVirtualHealthcare),
                description: i18n.t(tokens.labels.resources.detailsOfYourDialogueCoverage),
                onClick: () => this._navigateTo("https://d6hvupc5g7lnm.cloudfront.net/files/Dialogue_Primary_Care.pdf"),
                icon: 'Resources',
                testid: "open-dialogue"
            });
        }

        if (coverage.virtualHealthcare.benefitActive && coverage.virtualHealthcare.includeKii === 1) {
            tiles.push({
                title: i18n.t(tokens.labels.resources.kiiVirtualHealthcare),
                description: i18n.t(tokens.labels.resources.detailsOfYourKiiCoverage),
                onClick: () => this._navigateTo(i18n.locale === 'fr' ? 'https://d6hvupc5g7lnm.cloudfront.net/files/Kii_VirtualHealthcare_Fr.pdf' : 'https://d6hvupc5g7lnm.cloudfront.net/files/Kii_VirtualHealthcare_En.pdf'),
                icon: 'Resources',
                testid: "open-kii"
            });
        }

        if (coverage.drugs.benefitActive) {
            tiles.push({
                title: i18n.t(tokens.titles["pocketpills online pharmacy"]),
                description: i18n.t(tokens.labels.resources.detailsOfYourAccessToPocketpillsOnlinePharmacy),
                onClick: () => this._navigateTo("https://d6hvupc5g7lnm.cloudfront.net/files/PocketPills_ResourceDocument.pdf"),
                icon: 'Resources',
                testid: "open-dialogue"
            });
        }

        if (coverage.drugs.benefitActive && [ 'British Columbia', 'Saskatchewan', 'Manitoba' ].includes(province)) {
            tiles.push({
                title: i18n.t(tokens.labels.resources.pharmacare),
                description: i18n.t(tokens.labels.resources.pharmacareDescription),
                onClick: () => this._navigateTo("https://d6hvupc5g7lnm.cloudfront.net/files/Pharmacare Registration.pdf"),
                icon: 'Paid',
                testid: "open-dialogue"
            });
        }

        tiles.push({
            title: i18n.t(tokens.labels.resources.costSavingStrategies),
            description: i18n.t(tokens.labels.resources.aGuideOnHowToSaveMoneyWhenUsingMemberBenefits),
            onClick: () => this._navigateTo("https://d6hvupc5g7lnm.cloudfront.net/files/Cost-Saving-Strategies-Simply+Benefits.pdf"),
            icon: 'Resources',
            testid: "open-cost-savings"
        });

        if (coverage.outOfCountry.carrier === "AIG") {
            tiles.push({
                title: i18n.t(tokens.titles["oop coverage info"]),
                description: i18n.t(tokens.labels.resources.oopDetails),
                onClick: () => {
                    this._navigateTo("https://d6hvupc5g7lnm.cloudfront.net/files/AIG_and_Simply_Benefits_Emergency_OOP_OOC_Medical_Insurance.pdf");
                },
                icon: "Resources"
            });

            tiles.push({
                title: i18n.t(tokens.titles["aig travel assist"]),
                description: i18n.t(tokens.labels.resources.oopDetailsAig),
                onClick: () => {
                    this._navigateTo("https://d6hvupc5g7lnm.cloudfront.net/files/Flyer_Mobile_App_Canada_EN_MAY19.pdf");
                },
                icon: "Resources"
            });
        }

        if (coverage.outOfCountry.carrier === "Desjardins") {
            tiles.push({
                title: i18n.t(tokens.titles["oop coverage info"]),
                description: i18n.t(tokens.labels.resources.oopDetails),
                onClick: () => {
                    this._navigateTo(language === 'fr' ? "https://d6hvupc5g7lnm.cloudfront.net/files/Voyage_Assistance_Desjardins.pdf" : "https://d6hvupc5g7lnm.cloudfront.net/files/Travel_Assistance_Guidelines_Desjardins.pdf");
                },
                icon: "Resources"
            });
        }

        if (coverage.financialAwareness.benefitActive && coverage.financialAwareness.includeEnrichedAcademy === 1) {
            tiles.push({
                title: "Enriched Academy",
                description: i18n.t(tokens.labels.coverage.detailsOfYourEnrichedAcademyCoverage),
                onClick: () => this._navigateTo("https://d6hvupc5g7lnm.cloudfront.net/files/Enriched_Academy_Overview_Flyer.pdf"),
                icon: 'Resources',
                testid: "open-dialogue"
            });
        }

        if (coverage.paramedicals.benefitActive) {
            tiles.push({
                title: i18n.t(tokens.labels.resources.telusDirectBillingProviders),
                description: i18n.t(tokens.labels.resources.telusDirectBillingProvidersDescription),
                onClick: () => {
                    this._navigateTo("https://plus.telushealth.co/page/eclaims/discover/");
                },
                icon: "Adjudication",
                testid: "open-telus-direct-billing"
            });
        }

        return (
            <Container>
                <Content>
                    <Title title={ i18n.t(tokens.titles["forms and booklets"])} />
                    <Tiles tiles={ tiles }>
                        {
                            !tiles.length &&
                                <Text
                                    small
                                    margin="10px 0 5px 0"
                                    customStyle={{ maxWidth: 600 }}
                                >
                                    { i18n.t(tokens.labels.resources.whenFormsAndDocumentsAreAvailable) }
                                </Text>
                        }
                    </Tiles>
                </Content>

                <span id="resources" />

                {
                    this.state.loading &&
                        <Modal
                            open={ true }
                            onClose={ this._close }
                            title={ i18n.t(tokens.labels.resources.bookletDownloading) }
                        >
                            <div style={ styles.modalRow }>
                                <img style={ styles.gif } src={ whitelabel.loader || loadingGif } alt="loading..." />

                                <Text
                                    small
                                    margin="10px 0 5px 0"
                                    customStyle={{ width: "65%" }}
                                >
                                    { i18n.t(tokens.labels.resources.yourBookletIsBeingGenerated) }
                                </Text>
                            </div>

                        </Modal>
                }
                
            </Container>
        );
    }
}

Resources.propTypes = {
    user: PropTypes.object,
    whitelabel: PropTypes.object,
    coverage: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    user: state.user,
    whitelabel: state.whitelabel,
    coverage: state.coverage.data
});

export default connect(mapStateToProps)(Resources);